import { getSpApi } from "@/shared/apis/apiRoot";

export const getSecuredURL = async <QueryResult = string>(insurerLinkUrl: string): Promise<QueryResult> => {
    const { data } = await getSpApi().get<QueryResult>(insurerLinkUrl);
    return data;
};
